import React from "react";

export const RenderItemSection = ({ component: Component, props }) => {
  return <Component {...props} />;
};
